import jointImageSuffix from "@kkmh/image-format";

class KkmhImageFormat {
    /**
     * 原图格式化为适合页面显示图
     * 图宽处理：分为4档 - 180<360<720<1080  原图宽不足档位宽时返回原图宽
     * 终端返回格式: 安卓-webp   iOs-jpg(有透明度标示返回png)
     * 安卓格式化为webp, iOs格式化为jpg，当图片有透明度时格式化为png;
     * @method imageFormat
     * @static
     * @param {string} imgsrc - [必填] 图片地址
     * @param {number} vw - [必填] 屏幕显示宽度 设计稿宽度
     * @param {string} q - [可选] 支持值 h表示高质量，l，表示low低质量，默认 h。
     * @param {boolean} p - [可选] 表示图片渐进式 true/false 默认为true 只针对jpg格式有效
     * @param {number} opacity = [可选 弃用] 透明度 为了兼容之前的图片格式化版本 后续使用该方法无需传这个参数
     * @return {string} 格式化后地址
     */

    imageFormat({imgsrc="", vw=50, q="h", p=true}){
        // const _this = this;
        // imgsrc = _this.imageFilter(imgsrc);
        // imgsrc = _this.imageView(imgsrc, vw, opacity,  q); //_this.imageView(imgsrc, vw, opacity, interlace, q);原来值

        return jointImageSuffix({src: imgsrc, width: vw, quality: q, p});
    }


    imageFilter( imgsrc ) {
        let img="";
        // eslint-disable-next-line no-useless-escape
        let reg = /(-h(\.w\d+)([\.(jpg|webp|png)]*))|(-w\d+\.w\.(jpg|png|webp))|((-w\d+)([\.(jpg|webp|png)]*))/ig; //简写正则
        img = imgsrc.replace(reg,"");
        img = img.replace(/\.webp\.w\.jpg/, ".webp");

        //w320.webp

        return img;
    }

    imageView( imgsrc, vw, opacity , q ) { //imageView: function (imgsrc, vw, opacity, interlace, q) 原来值
        var option, imageView, resetImg, range, dpr;
        if (!imgsrc) {
            //console.warn("图片参数不能为空");
            return this;
        }
        if (!vw) {
            //console.warn("屏幕尺寸参数不能为空");
            return imgsrc;
        }
        range = [720, 360, 180];
        if (vw > range[0]) {
            vw = 1080;
        } else if (vw > range[1]) {
            vw = 720;
        } else if (vw > range[2]) {
            vw = 360;
        } else {
            vw = 180;
        }

        // 屏幕像素比
        // dpr = window.devicePixelRatio ? window.devicePixelRatio : 1;
        dpr = parseInt( window.devicePixelRatio ? window.devicePixelRatio : 1 );
        dpr = dpr < 1 ? 1 : dpr; //如果小于1的情况下, dpr复制为1
        dpr = dpr > 3 ? 3 : dpr; //如果大于3的情况下, dpr复制为3
        vw = vw * dpr;//图片尺寸


        let vwList = [3240,2160,1440,1080,720,540,360,180];
        if(vw<3240){
            vw = vwList.filter((i) => i>=vw).pop();
        }else{
            vw = 3240;
        }

        resetImg = imgsrc ? imgsrc : "";

        option = {
            w: vw,
            q: q == "l" ? "l" :( q == "m" ? "m" : ( q == "h" ? "h" : "m" ) ),
            format: "webp",
        };

        if (/ip(ad|hone|od).*os/.test(window.navigator.userAgent.toLowerCase())) {
            // ios
            option.format = "jpg";
            // 有透明度时
            if (opacity) {
                option.format = "png";
            }
        } else if (/android/.test(window.navigator.userAgent.toLowerCase())) {
            // adr
            option.format = "webp";
        }else{ //其他手机系统
            option.format = "jpg";
            // 有透明度时
            if (opacity) {
                option.format = "png";
            }
        }

        imageView=`-fe.w${parseInt(option.w)}.${option.format}.${option.q}.i1`;
        resetImg = resetImg + imageView;
        return resetImg;
    }
}

const  initImage = new KkmhImageFormat();
export {
    initImage,// 实例
    KkmhImageFormat //原始格式化图片类
};



// WEBPACK FOOTER //
// ./src/assets/js/SDK_copy/libs/sdk.imageFormat.js